module.exports = __webpack_public_path__ + "img/confidentiality.013044f.svg";